import React, { useState, useEffect, useCallback } from 'react';
import { IoClose, IoChevronBack, IoChevronForward } from 'react-icons/io5';
import './MediaLightbox.css';

const MediaLightbox = ({ mediaUrls, mediaTypes, initialIndex = 0, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const hasMultiple = mediaUrls.length > 1;

  const handlePrev = useCallback(() => {
    setCurrentIndex(prev => (prev > 0 ? prev - 1 : mediaUrls.length - 1));
  }, [mediaUrls.length]);

  const handleNext = useCallback(() => {
    setCurrentIndex(prev => (prev < mediaUrls.length - 1 ? prev + 1 : 0));
  }, [mediaUrls.length]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft' && hasMultiple) handlePrev();
      if (e.key === 'ArrowRight' && hasMultiple) handleNext();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose, hasMultiple, handlePrev, handleNext]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const isVideo = mediaTypes?.[currentIndex] === 'video';

  return (
    <div className="media-lightbox-overlay" onClick={handleBackdropClick}>
      <button className="lightbox-close" onClick={onClose}>
        <IoClose />
      </button>

      <div className="lightbox-content" onClick={handleBackdropClick}>
        {isVideo ? (
          <video
            key={currentIndex}
            src={mediaUrls[currentIndex]}
            controls
            autoPlay
            playsInline
            className="lightbox-media"
          />
        ) : (
          <img
            src={mediaUrls[currentIndex]}
            alt=""
            className="lightbox-media"
          />
        )}
      </div>

      {hasMultiple && (
        <>
          <button className="lightbox-nav prev" onClick={handlePrev}>
            <IoChevronBack />
          </button>
          <button className="lightbox-nav next" onClick={handleNext}>
            <IoChevronForward />
          </button>
          <div className="lightbox-counter">
            {currentIndex + 1} / {mediaUrls.length}
          </div>
        </>
      )}
    </div>
  );
};

export default MediaLightbox;
